import { render, staticRenderFns } from "./step-title1.vue?vue&type=template&id=56b0b48e&scoped=true&lang=pug&"
import script from "./step-title1.vue?vue&type=script&lang=js&"
export * from "./step-title1.vue?vue&type=script&lang=js&"
import style0 from "./step-title1.vue?vue&type=style&index=0&id=56b0b48e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b0b48e",
  null
  
)

export default component.exports